module.exports = __webpack_public_path__ + "dental candidate profile.svg?b17dd381df963490000d4a35f1182d69";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mobileapp/dental candidate profile.svg
// module id = 363
// module chunks = 0